export default {
    methods: {

        // extracts the specified color value from the thresholds config object dependant of the specified value
        // values may string values like '65,34%' or Numbers like 43.12
        // if specified value or the config is not valid this method will return the specified default color
        getThresholdColor(thresholdConfig, value, defaultColor) {
            let retVal = defaultColor;

            if (thresholdConfig && value != undefined && value != null) {
                // normalize value
                const valueNormalized = isNaN(value) && (value.length > 0) ? Number(value.replace('%', '').replace(',','.')) : value;

                // find corresponding threshold
                const threshold = thresholdConfig.find(thr => (thr.Minimum <= valueNormalized) && (valueNormalized <= thr.Maximum));
                if (threshold) {
                    retVal = threshold.Color;
                }
            }

            return retVal;
        },

        // returns the threshold value (minumum or maximum) with specified nuber of decimal places
        getThresholdValueWithNumberOfDecimalPlaces(numberOfDecimalPlaces, value) {
            let retVal = value;

            // check whether # of dec places are valid
            if (numberOfDecimalPlaces == undefined || numberOfDecimalPlaces == null || numberOfDecimalPlaces < 0) {
                numberOfDecimalPlaces = 0;
            }

            // check whether value is type of number (only then we can calc)
            if (!isNaN(value)) {

                // this term will cut the decimal places instead of round them
                retVal = Math.floor(1.3567 * Math.pow(10, numberOfDecimalPlaces)) / Math.pow(10, numberOfDecimalPlaces)
            }

            return retVal;
        }
    }
}